/* This example requires Tailwind CSS v2.0+ */
import {
  BoltIcon,
  ArrowPathIcon,
  ArrowTrendingUpIcon,
  PencilIcon,
  ChartBarIcon,
  DocumentCheckIcon,
  AcademicCapIcon,
  HeartIcon,
} from "@heroicons/react/24/outline";

const features = [
  {
    name: "Respuesta inmediata",
    description:
      "Nuestra tecnología procesará tu información en tiempo real y te responderá al instante.",
    icon: AcademicCapIcon,
  },
  {
    name: "Desembolso rápido",
    description: "Recibe tu dinero en menos de 24 horas hábiles.",
    icon: BoltIcon,
  },
  {
    name: "Cupo de crédito",
    description: "Crédito rotativo siempre disponible cuando lo necesites.",
    icon: ArrowPathIcon,
  },
  {
    name: "Certificado de cumplimiento",
    description:
      "Recibe certificados que te ayudará a acceder a créditos en otras entidades.",
    icon: ArrowTrendingUpIcon,
  },
  {
    name: "Firma electrónica",
    description:
      "Realiza solicitudes, cambios y ajustes a tu crédito a un clic.",
    icon: PencilIcon,
  },
  {
    name: "Cuenta Galilea",
    description:
      "Ten el control de tu vida financiera para no perder de vista la evolución de tus créditos",
    icon: ChartBarIcon,
  },
  {
    name: "Sin papeleos ni filas",
    description:
      "Evita papeleos, trámites y desplazamientos usando nuestro servicio de Firma Electrónica",
    icon: DocumentCheckIcon,
  },
  {
    name: "Mejoras calidad de vida",
    description: "Cumple tus metas gracias a un buen comportamiento de pago.",
    icon: HeartIcon,
  },
];

export function Benefits() {
  return (
    <section
      className="bg-redLight font-walsheim text-tdark"
      aria-labelledby="benefits-title"
    >
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:pt-24 lg:px-8">
        <h2
          id="benefits-title"
          className="text-4xl font-bold tracking-tight sm:text-5xl"
        >
          Beneficios de unirte a Galilea
        </h2>
        <h3 className="mt-4 max-w-3xl text-xl font-medium">
          Cuando haces parte de Galilea tienes acceso a los siguientes
          beneficios
        </h3>
        <div className="mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-16">
          {features.map((feature) => (
            <div key={feature.name}>
              <div>
                <span className="flex items-center justify-center h-12 w-12 rounded-md text-grayP bg-purpleLight">
                  <feature.icon className="h-6 w-6" aria-hidden="true" />
                </span>
              </div>
              <div className="mt-6">
                <h3 className="text-xl font-bold">{feature.name}</h3>
                <p className="mt-2 text-lg">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
